<template>
  <TPureContextActionMenuItem
    :key="item.name"
    :variant="item.type ?? 'primary'"
    @click="item.action()"
  >
    <TIcon v-if="!!item.icon" :name="item.icon" />
    <span>{{ item.name }}</span>
  </TPureContextActionMenuItem>
</template>

<script lang="ts" setup>
import TIcon from '../Icon/TIcon.vue';
import { type ContextActionMenuItem } from './context-action-menu-item';
import TPureContextActionMenuItem from './TPureContextActionMenuItem.vue';

defineProps<{
  item: ContextActionMenuItem;
}>();
</script>
